/**
 * Optimizes Cloudinary images without changing the original image.
 *
 * Features:
 * - Automatically serves WebP/AVIF when supported (f_auto)
 * - Automatically selects the best quality (q_auto)
 * - Resizes before download to reduce bandwidth
 *
 * Example:
 * optimizeCloudinaryImage(url, 160, 160)
 */

export const optimizeCloudinaryImage = (
  url: string,
  width = 160,
  height = 160
): string => {
  if (!url || !url.includes("res.cloudinary.com")) {
    return url;
  }

  // Already optimized
  if (url.includes("/upload/w_")) {
    return url;
  }

  return url.replace(
    "/upload/",
    `/upload/w_${width},h_${height},c_fill,f_auto,q_auto/`
  );
};